import { useAtomValue } from "jotai";
import { financialSummaryAtomFamily } from "../atoms/financial-summary.atom";
import type { Order } from "../types";

export function useFinancialSummary(orderId: string, order: Order | null) {
  return useAtomValue(financialSummaryAtomFamily({ orderId, order }));
}
